import script from "./katsubetPromo.vue?vue&type=script&lang=ts&setup=true"
export * from "./katsubetPromo.vue?vue&type=script&lang=ts&setup=true"

import "./katsubetPromo.vue?vue&type=style&index=0&id=57c597fc&lang=scss"

const __exports__ = script;

export default __exports__